const CHARGES_ACCOUNT_TYPE_ENUM = {
  SAVINGS: 'savings',
  CHECKING: 'checking',
  CONJUNCT_CHECKING: 'conjunct_checking',
  CONJUNCT_SAVINGS: 'conjunct_savings'
}

const isSavings = accountType =>
  accountType.toLowerCase() === CHARGES_ACCOUNT_TYPE_ENUM.SAVINGS
const isChecking = accountType =>
  accountType.toLowerCase() === CHARGES_ACCOUNT_TYPE_ENUM.CHECKING
const isConjuctChecking = accountType =>
  accountType.toLowerCase() === CHARGES_ACCOUNT_TYPE_ENUM.CONJUNCT_CHECKING
const isConjuctSavings = accountType =>
  accountType.toLowerCase() === CHARGES_ACCOUNT_TYPE_ENUM.CONJUNCT_SAVINGS

export {
  CHARGES_ACCOUNT_TYPE_ENUM,
  isSavings,
  isChecking,
  isConjuctChecking,
  isConjuctSavings
}
